var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doink"},[_c('div',{staticClass:"offline-msg"},[_c('p',[_vm._v(_vm._s(_vm.__('Ugh, no internet. You’re in temporary read-only mode.')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }